import React from "react";
import {
  Card,
  Box,
  Typography,
  Avatar,
  IconButton,
  Divider,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AddIcon from "@mui/icons-material/Add";

interface KanbanCardProps {
  name: string;
  email: string;
  phone: string;
  level: string;
  time: string;
  status?: string;
}

const KanbanCard: React.FC<KanbanCardProps> = ({
  name,
  email,
  phone,
  level,
  time,
  status = "Followup Done",
}) => {
  const initial = name.charAt(0).toUpperCase();

  return (
    <Card
      variant="outlined"
      sx={{
        p: 2,
        mb: 2,
        borderRadius: 2,
        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
        "&:hover": { boxShadow: "0 4px 12px rgba(0,0,0,0.15)" },
      }}
    >
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box display="flex" alignItems="center" gap={1.5}>
          <Avatar
            sx={{
              bgcolor: "#2196f3",
              width: 32,
              height: 32,
              fontSize: 14,
              textTransform: "uppercase",
            }}
          >
            {initial}
          </Avatar>
          <Typography variant="subtitle1" fontWeight="500" fontSize={"16px"}>
            {name}
          </Typography>
        </Box>
        <Typography
          variant="body2"
          sx={{ color: "#e91e63", fontWeight: 400, whiteSpace: "nowrap",fontSize:"14px" }}
        >
          {status}
        </Typography>
      </Box>

      <Divider sx={{ my: 1.5 }} />

      {/* Details */}
      <Box>
        <Typography
          variant="body2"
          sx={{ fontWeight: 400, fontSize: 14, lineHeight: 2.0 }}
        >
          {email}
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontWeight: 400, fontSize: 14, lineHeight: 2.0 }}
        >
          {phone}
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontWeight: 400, fontSize: 14, lineHeight: 2.0 }}
        >
          Level: {level}
        </Typography>
      </Box>

      <Divider sx={{ my: 1.5 }} />

      {/* Footer */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box display="flex" alignItems="center" gap={0.5}>
          <AccessTimeIcon
            sx={{
              fontSize: 22,
              color: "text.secondary",
              backgroundColor: "#D9D9D9",
              borderRadius: "50%",
              padding: "2px",
            }}
          />
          <Typography variant="caption" color="text.secondary" fontSize={"14px"}>
            {time}
          </Typography>
        </Box>
        <IconButton
          size="small"
          sx={{
            color: "text.secondary",
            backgroundColor: "#D9D9D9",
            borderRadius: "50%",
          }}
        >
          <AddIcon fontSize="small" />
        </IconButton>
      </Box>
    </Card>
  );
};

export default KanbanCard;
